<style scoped lang="scss">
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/qunlong/first/inspection/page"
                   getKey="rows"
                   :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('wmsshoujiandanid')">
            <el-input v-model="yt.conditions.wmsFirstInspectionId"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.woNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="yt.conditions.erpNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('leixing')">
            <yi_dictionary_select :multiple="false" :max="1" :type="'BIND_FIRST_ORDER_TYPE_DICT_KEY'"
                                  :ids.sync="yt.conditions.source">
            </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('chuangjianshijian')">
            <yi_time_input format="yyyy-MM-dd HH:mm:ss" type="daterange"
                           :start.sync="yt.conditions.startTime"
                           :end.sync="yt.conditions.endTime">
            </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain>
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button v-if="scope.row.btnFlag" type="text"
                       @click="yt.showEditDialog('bangdingshengchangongdan', scope.row,'70%')">
              {{ $t('bangdingshengchangongdan') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
               :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 领料出库 -->
      <template v-if="yt.editObj.action == 'bangdingshengchangongdan'">
        <div class="dialog-scroller">
          <wo_page_list ref="woPageRef" :wo="yt.editObj"></wo_page_list>
        </div>
        <span slot="footer" class="dialog-footer">
						<el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
						<el-button :loading="store.state.global_loading" size="mini"
                       @click="yt.req('POST','/custom/qunlong/first/inspection/create',beforeAdd)" type="primary">
							{{ $t('baocun') }}
						</el-button>
					</span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import out_stock from '@@/pages/web/production_management/picking/out_stock'
import wo_page_list from '@@/pages/web/customize/qunlong/production_management/bind_first_order/wo_list_page'

export default {
  name: 'web_production_management_picking_list',
  components: {
    out_stock,
    wo_page_list
  },
  data() {
    return {
      list: [],
      columns: [
        {
          label: 'wmsshoujiandanid',
          prop: 'wmsFirstInspectionId',
          width: 230,
        },
        {
          label: 'shengchangongdanhao',
          prop: 'woNo',
          width: 230,
        },
        {
          label: 'ERPgongdanhao',
          prop: 'erpNo',
          width: 230,
        },
        {
          label: 'chanpinbianma',
          prop: 'basicMaterial.code',
          width: 230,
        },
        {
          label: 'chanpinmingcheng',
          prop: 'basicMaterial.name',
          width: 230,
        },
        {
          label: 'mojumingcheng',
          prop: 'basicMould.name',
          width: 230,
        },

        {
          label: 'leixing',
          prop: 'source',
          type: 'dictionary',
          key: 'BIND_FIRST_ORDER_TYPE_DICT_KEY',
          width: 160,
        }, {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 230,
        }, {
          label: 'chuangjianren',
          prop: 'createByObject.nickname',
          width: 130,
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 200,
          fixed: 'right'
        }
      ],
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
      // this.$set(this.yt.conditions, 'createTimeStart', this.begin())
      // this.$set(this.yt.conditions, 'createTimeEnd', this.end())
      // this.yt.list = []
      console.log('kkkk', this.yt.conditions)
    }, 300)

  },
  methods: {
    beforeAdd(editObj) {
      let selectedRows = this.$refs.woPageRef.selectedRows;
      const rowObj = editObj;
      console.log('editobj:',editObj)
      console.log('selectedRows:', selectedRows)
      editObj = selectedRows;
      editObj.woNo = selectedRows.no;
      editObj.woId = selectedRows.id;
      editObj.wmsFirstInspectionId = rowObj.wmsFirstInspectionId;
      editObj.wmsInspectionNumber = rowObj.wmsInspectionNumber;
      return editObj;
    },
  },
};
</script>
